import React from 'react';
import BanterLoader, { type BanterLoaderSize } from '../../../shared/design/components/BanterLoader';

interface SpinnerIconProps {
    className?: string;
    size?: BanterLoaderSize;
}

/**
 * Backward-compat: this used to render a spinning SVG. It now renders the
 * BanterLoader to keep loading visuals consistent across the app.
 * The `className` prop is preserved (applied to the wrapper) — size is
 * inferred from `h-X w-X` patterns, or pass `size` explicitly.
 */
export const SpinnerIcon: React.FC<SpinnerIconProps> = ({ className, size }) => {
    let resolvedSize: BanterLoaderSize = size ?? 'xs';
    if (!size && className) {
        if (/\b(h|w)-(3|4)\b/.test(className)) resolvedSize = 'xs';
        else if (/\b(h|w)-(5|6|7|8)\b/.test(className)) resolvedSize = 'sm';
        else if (/\b(h|w)-(9|10|12|14)\b/.test(className)) resolvedSize = 'md';
        else if (/\b(h|w)-(16|20|24)\b/.test(className)) resolvedSize = 'lg';
    }
    return <BanterLoader size={resolvedSize} className={className} />;
};
